
export class ServiceLogModelNew {
  id: number;
  httpMethod: string;
  url: string;
  actionType: string;
  requestPayload: string;
  responsePayload: string;
  responseCode: string;
  responseDurationMs: string;
  traceId: string;
  spanId: string;
  requestDateTime: string;
  responseDateTime: string;


  public constructor(init?: Partial<ServiceLogModelNew>) {
    Object.assign(this, init);
  }
}
